import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import SectionTitle from 'components/Presentation/SectionTitle';
import Modal from 'containers/Modals/Modal';
import StudentDetailsForm from 'containers/Forms/StudentDetailsForm';
import GuardianDetailsForm from 'containers/Forms/GuardianDetailsForm';
import { getUserInfo, updateUser, getUserGuardian, setUserGuardian, setUserAuthoritative, getUserGuardianByEmail, linkStudentGuardian, addUserGuardian, deleteStudentGuardian, updateUserPhoneNumber } from 'actions/user';
import { Flex, Skeleton, TooltipMenu, Button, Icon } from '@haldor/ui';
import Block, { BlockHeader, BlockContent } from "UI/Elements/Block";
import swal from 'sweetalert2';
import User from '_class/User';

var UserDetails = /*#__PURE__*/function (_Component) {
  _inherits(UserDetails, _Component);

  var _super = _createSuper(UserDetails);

  function UserDetails(props) {
    var _this;

    _classCallCheck(this, UserDetails);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.user != null) {
        _this.setState({
          currentStudent: _this.props.currentStudent
        });

        _this.props.getUserGuardian(_this.props.user).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (type, object) {
      if (type == "guardian") {
        _this.setState({
          modal: !_this.state.modal,
          currentGuardian: object,
          modalType: "guardian"
        });
      } else if (type == "user") {
        _this.setState({
          modal: !_this.state.modal,
          currentGuardian: {},
          modalType: "user"
        });
      } else {
        _this.setState({
          modal: !_this.state.modal
        });
      }

      var promises = [];
      promises.push(_this.props.getUserGuardian(_this.props.user));
      Promise.all(promises).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentUpdate", function (userItem) {
      var user = new User(_this.props.currentUser);

      _this.setState({
        loading: true
      });

      var promises = [];

      _this.props.updateUser(userItem).then(function () {
        if (user.isAdministrator()) {
          userItem.guardians.forEach(function (guardian, index) {
            promises.push(_this.props.setUserGuardian(_this.props.user, guardian));
          });
        }

        if (userItem.mobilePhone != null) {
          promises.push(_this.props.updateUserPhoneNumber(userItem));
        }

        Promise.all(promises).then(function (response) {
          _this.props.getUserInfo(_this.props.user, "extended", true).then(function (response) {
            _this.props.getUserGuardian(_this.props.user).then(function () {
              _this.setState({
                loading: false,
                currentStudent: _this.props.currentStudent
              });

              _this.toggleModal("user", null);
            });
          });
        })["catch"](function (error) {
          console.error(error.message);

          _this.setState({
            loading: false
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onModalCancel", function () {
      _this.toggleModal("user", null);

      _this.setState({
        loading: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardianModalCancel", function () {
      _this.toggleModal("guardian", null);

      _this.props.getUserGuardian(_this.props.user).then(function () {
        var currentStudent = _objectSpread({}, _this.state.currentStudent);

        currentStudent.guardians = _this.props.guardians;

        _this.setState({
          currentStudent: currentStudent
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentAuthoritativeUpdate", function (userId, authoritative) {});

    _defineProperty(_assertThisInitialized(_this), "onGuardianStatusChange", function (guardian, status) {});

    _defineProperty(_assertThisInitialized(_this), "onGuardianUpdate", function (guardian) {
      if (guardian.id != "") {
        _this.props.setUserGuardian(_this.props.user, guardian).then(function () {
          _this.props.getUserGuardian(_this.props.user);

          _this.props.getUserInfo(_this.props.user, "extended");

          _this.toggleModal();
        });
      } else {
        _this.props.getUserGuardianByEmail(guardian.mail).then(function () {
          if (_this.props.guardianByMail != null && _this.props.guardianByMail != "" && _this.props.guardianByMail.mail.toLowerCase() == guardian.mail.toLowerCase()) {
            var alreadyLinked = _this.props.guardians.findIndex(function (g) {
              return _this.props.guardianByMail.id == g.id;
            });

            if (alreadyLinked == -1) {
              _this.props.linkStudentGuardian(_this.props.user, _this.props.guardianByMail.id);
            }

            var guardianByMail = _this.props.guardianByMail;
            guardianByMail.active = guardian.active;
            guardianByMail.lcid = guardian.lcid;

            _this.props.setUserGuardian(_this.props.user, guardianByMail);

            _this.toggleModal();
          } else {
            _this.props.addUserGuardian(_this.props.user, guardian).then(function () {
              _this.toggleModal();
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMailChanged", function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (re.test(String(email).toLowerCase())) {
        _this.setState({
          searchingGuardian: true
        });

        _this.props.getUserGuardianByEmail(email).then(function () {
          _this.setState({
            searchingGuardian: false
          });

          if (_this.props.guardianByMail != null && _this.props.guardianByMail != "" && _this.props.guardianByMail.mail.toLowerCase() == email.toLowerCase()) {
            var guardian = _this.props.guardianByMail;
            guardian.id = "";
            guardian.active = true;

            _this.toggleModal();

            _this.toggleModal("guardian", guardian);
          } else {
            _this.toggleModal();

            _this.toggleModal("guardian", {
              id: "",
              firstName: "",
              lastName: "",
              mail: email,
              phone: "",
              postal: "",
              street: "",
              active: true
            });
          }

          ;
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardianDelete", function (guardian) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Delete')
      }).then(function (response) {
        if (response.value != null) {
          _this.props.getUserGuardianByEmail(guardian.mail).then(function () {
            if (_this.props.guardianByMail != null && _this.props.guardianByMail != "" && _this.props.guardianByMail.mail.toLowerCase() == guardian.mail.toLowerCase()) {
              if (_this.props.guardianByMail.students.length > 1) {
                swal.fire({
                  title: _this.props.translate('remove-completely'),
                  text: _this.props.translate('remove-guardian-completely'),
                  showCancelButton: true,
                  cancelButtonText: _this.props.translate('remove-for-current-student'),
                  confirmButtonText: _this.props.translate('remove-for-all-students')
                }).then(function (response) {
                  if (response.value != null) {
                    _this.props.deleteStudentGuardian(_this.props.user, guardian.id, true).then(function () {
                      _this.props.getUserGuardian(_this.props.user).then(function () {
                        var currentStudent = _this.state.currentStudent;
                        currentStudent.guardians = _this.props.guardians;

                        _this.setState({
                          currentStudent: currentStudent
                        });
                      });
                    });
                  } else {
                    _this.props.deleteStudentGuardian(_this.props.user, guardian.id, false).then(function () {
                      _this.props.getUserGuardian(_this.props.user).then(function () {
                        var currentStudent = _this.state.currentStudent;
                        currentStudent.guardians = _this.props.guardians;

                        _this.setState({
                          currentStudent: currentStudent
                        });
                      });
                    });
                  }
                });
              } else {
                _this.props.deleteStudentGuardian(_this.props.user, guardian.id, true).then(function () {
                  _this.props.getUserGuardian(_this.props.user).then(function () {
                    var currentStudent = _this.state.currentStudent;
                    currentStudent.guardians = _this.props.guardians;

                    _this.setState({
                      currentStudent: currentStudent
                    });
                  });
                });
              }
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isUserSchoolAdmin", function () {
      if (_this.props.roles != null && _this.props.roles.length > 0) {
        var schoolAdministrator = _this.props.roles.find(function (role) {
          return role.roleId.toUpperCase() == "SCHOOL_ADMINISTRATOR" && role.referenceId == _this.props.activeSchool || role.roleId.toUpperCase() == "SYSADMIN" && role.referenceId == _this.props.activeSchool;
        });

        if (schoolAdministrator != null) {
          return true;
        }
      }

      return false;
    });

    _this.state = {
      loading: true,
      modal: false,
      modalType: "user",
      currentGuardian: null,
      currentStudent: null,
      searchingGuardian: false
    };
    return _this;
  }

  _createClass(UserDetails, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var translate = this.props.translate;
      var user = new User(this.props.currentUser);

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, this.props.translate('Student'))), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockHeader, null, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 325
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '.95rem'
          }
        })), /*#__PURE__*/React.createElement(BlockContent, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 125
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null))), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 155
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null)))))), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '2rem'
          }
        }), /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, this.props.translate('Guardians'))), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockHeader, null, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 325
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '.95rem'
          }
        })), /*#__PURE__*/React.createElement(BlockContent, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 125
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null))), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 155
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null)))))), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockHeader, null, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 325
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '.95rem'
          }
        })), /*#__PURE__*/React.createElement(BlockContent, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 125
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null))), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 155
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null)))))));
      }

      var triggerButton = /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0
        }
      }, "⋯");
      return /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          padding: 0,
          margin: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, this.props.translate('Student'))), /*#__PURE__*/React.createElement(Modal, {
        onClose: this.toggleModal,
        title: this.state.modalType == "user" ? this.props.translate('edit-student') : this.state.currentGuardian != null && this.state.currentGuardian.id == "" ? this.props.translate('add-guardian') : this.props.translate('edit-guardian'),
        isOpen: this.state.modal,
        type: "small"
      }, this.state.modalType == "user" ? /*#__PURE__*/React.createElement(StudentDetailsForm, {
        currentStudent: this.state.currentStudent,
        cancelModal: this.onModalCancel,
        onModalSave: this.onStudentUpdate,
        onStudentAuthoritativeUpdate: this.onStudentAuthoritativeUpdate,
        onGuardianStatusChange: this.onGuardianStatusChange
      }) : /*#__PURE__*/React.createElement(GuardianDetailsForm, {
        currentGuardian: this.state.currentGuardian,
        cancelModal: this.onGuardianModalCancel,
        onModalSave: this.onGuardianUpdate,
        onMailChanged: this.onMailChanged,
        searchingGuardian: this.state.searchingGuardian,
        errorMessage: this.props.guardianByMail === 'error' ? this.props.translate('error-occured') : null
      })), /*#__PURE__*/React.createElement(Block, {
        key: 'student' + this.props.currentStudent.userId
      }, /*#__PURE__*/React.createElement(BlockHeader, null, this.props.currentStudent.firstName, " ", this.props.currentStudent.lastName, user.isAdministrator() || user.isMentor() || user.isSchoolLeader() ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "right"
        }
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: triggerButton,
        id: this.props.currentStudent.userId
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this2.toggleModal("user", null);
        }
      }, this.props.translate('Edit')))) : null), /*#__PURE__*/React.createElement(BlockContent, {
        style: {
          paddingTop: '0px'
        }
      }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, this.props.currentStudent.email != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.55rem'
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('e-mail')), /*#__PURE__*/React.createElement("br", null), this.props.currentStudent.email) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, this.props.currentStudent.mobilePhone != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.55rem'
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('Phone number')), /*#__PURE__*/React.createElement("br", null), this.props.currentStudent.mobilePhone) : null)))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }), /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, this.props.translate('Guardians')), user.isAdministrator() ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return _this2.toggleModal("guardian", {
            id: "",
            firstName: "",
            lastName: "",
            mail: "",
            phone: "",
            postal: "",
            street: "",
            active: true
          });
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate("Add")) : null), this.props.guardians.map(function (guardian) {
        if (guardian != null && guardian.active) {
          return /*#__PURE__*/React.createElement(Block, {
            key: 'guardian' + guardian.id
          }, /*#__PURE__*/React.createElement(BlockHeader, null, guardian.firstName, " ", guardian.lastName != null ? guardian.lastName : '', user.isAdministrator() && !guardian.synced ? /*#__PURE__*/React.createElement("div", {
            style: {
              "float": "right"
            }
          }, /*#__PURE__*/React.createElement(TooltipMenu, {
            trigger: triggerButton,
            id: guardian.id
          }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              return _this2.toggleModal("guardian", guardian);
            }
          }, _this2.props.translate('Edit')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              return _this2.onGuardianDelete(guardian);
            }
          }, _this2.props.translate('Delete')))) : null), /*#__PURE__*/React.createElement(BlockContent, {
            style: {
              paddingTop: '0px'
            }
          }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, guardian.phone != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '.55rem'
            }
          }, /*#__PURE__*/React.createElement("strong", null, translate('phone')), /*#__PURE__*/React.createElement("br", null), guardian.phone) : null, guardian.mail != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '.55rem'
            }
          }, /*#__PURE__*/React.createElement("strong", null, translate('e-mail')), /*#__PURE__*/React.createElement("br", null), guardian.mail) : null), /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, guardian.street != null && guardian.postal != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '.55rem'
            }
          }, /*#__PURE__*/React.createElement("strong", null, translate('address')), /*#__PURE__*/React.createElement("br", null), guardian.street, /*#__PURE__*/React.createElement("br", null), guardian.postal, ", ", guardian.city) : null))));
        }
      }), this.props.guardians.some(function (g) {
        return g != null && g.active == false;
      }) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }), /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, this.props.translate('archived-guardian'))), this.props.guardians.map(function (guardian) {
        if (!guardian.active) {
          return /*#__PURE__*/React.createElement(Block, {
            key: 'guardian' + guardian.id
          }, /*#__PURE__*/React.createElement(BlockHeader, null, guardian.firstName, " ", guardian.lastName != null ? guardian.lastName : '', " ", guardian.synced, user.isAdministrator() && !guardian.synced ? /*#__PURE__*/React.createElement("div", {
            style: {
              "float": "right"
            }
          }, /*#__PURE__*/React.createElement(TooltipMenu, {
            trigger: triggerButton,
            id: guardian.id
          }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              return _this2.toggleModal("guardian", guardian);
            }
          }, _this2.props.translate('Edit')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              return _this2.onGuardianDelete(guardian);
            }
          }, _this2.props.translate('Delete')))) : null), /*#__PURE__*/React.createElement(BlockContent, {
            style: {
              paddingTop: '0px'
            }
          }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, guardian.phone != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '.55rem'
            }
          }, /*#__PURE__*/React.createElement("strong", null, translate('phone')), /*#__PURE__*/React.createElement("br", null), guardian.phone) : null, guardian.mail != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '.55rem'
            }
          }, /*#__PURE__*/React.createElement("strong", null, translate('e-mail')), /*#__PURE__*/React.createElement("br", null), guardian.mail) : null), /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, guardian.street != null && guardian.postal != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '.55rem'
            }
          }, /*#__PURE__*/React.createElement("strong", null, translate('address')), /*#__PURE__*/React.createElement("br", null), guardian.street, /*#__PURE__*/React.createElement("br", null), guardian.postal, ", ", guardian.city) : null))));
        }
      })) : null);
    }
  }]);

  return UserDetails;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    activeSchool: state.user.activeSchool,
    guardians: state.user.guardians,
    userRoles: state.user.currentUser.userRoles,
    roles: state.user.currentUser.roles,
    guardianByMail: state.user.searchGuardian,
    currentStudent: state.user.info.find(function (u) {
      return u.userId == ownProps.user;
    })
  };
}

export default connect(mapStateToProps, {
  getUserInfo: getUserInfo,
  getUserGuardian: getUserGuardian,
  setUserGuardian: setUserGuardian,
  setUserAuthoritative: setUserAuthoritative,
  updateUser: updateUser,
  getUserGuardianByEmail: getUserGuardianByEmail,
  linkStudentGuardian: linkStudentGuardian,
  addUserGuardian: addUserGuardian,
  deleteStudentGuardian: deleteStudentGuardian,
  updateUserPhoneNumber: updateUserPhoneNumber
})(UserDetails);